import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	issueTypes: {
		id: 'spa-apps-sidebar-next-gen.menu.settings.issue-types.issue-types',
		defaultMessage: 'Issue types',
		description: 'title for issue types navigation item',
	},
	addIssueType: {
		id: 'spa-apps-sidebar-next-gen.menu.settings.issue-types.add-issue-type',
		defaultMessage: 'Add issue type',
		description: 'Button in navigation sidebar. Opens a modal dialog',
	},
	issueTypesIssueTermRefresh: {
		id: 'spa-apps-sidebar-next-gen.menu.settings.issue-types.issue-types-issue-term-refresh',
		defaultMessage: 'Work types',
		description: 'title for issue types navigation item',
	},
	addIssueTypeIssueTermRefresh: {
		id: 'spa-apps-sidebar-next-gen.menu.settings.issue-types.add-issue-type-issue-term-refresh',
		defaultMessage: 'Add work type',
		description: 'Button in navigation sidebar. Opens a modal dialog',
	},
});
